/**
 * Identité d'une copie de mail côté FrontEnd.
 *
 * Le SDK expose `Mail.uniqueMailvistaId?` (stampé au Record), mais le champ est OPTIONNEL : certains mails
 * bruts (ex. `sentMail` émis par l'event `thread-updated` hors Record) arrivent sans. On dérive alors
 * localement la même valeur que le noyau jumeau du SDK : `` `${internetMessageId}::${parentFolderId}` ``.
 *
 * Les helpers du noyau jumeau SDK (`mailIdentity.ts`) ne sont PAS exportés par le package — d'où cet util local.
 * Cf. Doc/identite-mail/14_plan-implementation-frontend.md §A.0 + WS-F0.
 */

/** Vue structurelle minimale suffisante pour calculer l'identité d'une copie. */
type MailCopyRef = {
    internetMessageId: string;
    parentFolderId: string;
};

/** Identité de la COPIE physique : `${internetMessageId}::${parentFolderId}`. */
export const deriveUniqueMailvistaId = ({
    internetMessageId,
    parentFolderId,
}: MailCopyRef): string => `${internetMessageId}::${parentFolderId}`;

/** Deux mails désignent-ils la même copie physique ? (comparaison par `uniqueMailvistaId`). */
export const isSameCopy = (
    a: { uniqueMailvistaId: string },
    b: { uniqueMailvistaId: string },
): boolean => a.uniqueMailvistaId === b.uniqueMailvistaId;
